export default function Hero() {
  return (
    <section id="top" className="relative">
      <div className="relative h-[100svh] min-h-[600px] w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20oriental%20landscape%20with%20deep%20flowing%20ink%20brush%20strokes%20resembling%20a%20winding%20river%20misty%20mountains%20and%20warm%20dusk%20haze%20rich%20cinnabar%20red%20deep%20amber%20and%20dark%20bronze%20palette%20subtle%20rice%20paper%20texture%20moody%20minimalist%20eastern%20aesthetic%20no%20text%20no%20people&width=1920&height=1080&seq=nomo-hero-main-01&orientation=landscape&nocache=true"
          alt="NOMOISM 东方潮玩世界：一味一境一愿的抽象东方山水意象"
          title="NOMOISM 东方潮玩 · 一味一境一愿"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35"></div>

        <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center">
          <p
            className="reveal mb-6 text-[10px] md:text-xs tracking-[0.42em] text-background-50/80 uppercase"
            style={{ transitionDelay: '80ms' }}
          >
            From Chinese Flavor to a New Eastern Playground
          </p>

          <h1
            className="reveal font-heading text-4xl md:text-6xl lg:text-7xl font-medium leading-tight text-background-50"
            style={{ transitionDelay: '200ms' }}
          >
            一味 <span className="mx-1 text-accent-300">×</span> 一境{' '}
            <span className="mx-1 text-accent-300">×</span> 一愿
          </h1>

          <p
            className="reveal mt-6 text-xs md:text-sm tracking-[0.36em] text-background-50/85 uppercase"
            style={{ transitionDelay: '340ms' }}
          >
            One Flavor. One Place. One Wish.
          </p>

          <div
            className="reveal mt-8 h-px w-16 bg-background-50/40"
            style={{ transitionDelay: '440ms' }}
          ></div>

          <p
            className="reveal mt-8 max-w-xl text-sm md:text-base leading-relaxed text-background-50/90"
            style={{ transitionDelay: '520ms' }}
          >
            Welcome to <span className="font-heading tracking-[0.2em]">NOMOISM</span>
            <br className="hidden md:block" />
            从中国美食出发，进入东方风土，回应当代人的愿望。
          </p>

          <div
            className="reveal mt-10 flex flex-col sm:flex-row items-center gap-3"
            style={{ transitionDelay: '640ms' }}
          >
            <a
              href="#world"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3.5 text-sm tracking-[0.1em] text-background-50 transition-colors duration-300 hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              进入 NOMOISM 世界
              <i className="ri-arrow-down-line"></i>
            </a>
            <a
              href="#characters"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-full border border-background-50/50 px-7 py-3.5 text-sm tracking-[0.1em] text-background-50 transition-colors duration-300 hover:bg-background-50/10 cursor-pointer whitespace-nowrap"
            >
              认识鱼豆豆
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-background-50/70">
          <i className="ri-arrow-down-double-line animate-nomo-float text-xl"></i>
        </div>
      </div>
    </section>
  );
}